define('environments/preproduction',{
  apiHost: 'https://landings-backend.pre.mdirector.com',
  authHost: 'https://signup-backend.pre.mdirector.com/auth/accessLandings',
  loginUrl: 'https://signup-backend.pre.mdirector.com/auth/landings',
  defaultDomain: 'https://landings.pre.mdirector.com',
  signupUrl: 'https://signup.pre.mdirector.com',
  signupBackendUrl: 'https://signup-backend.pre.mdirector.com',
  logoutUrl: 'https://signup-backend.pre.mdirector.com/auth/logoutLandings',
  i18nCookieDomain: '.mdirector.com',
  cdnDomain: 'https://landings-backend.pre.mdirector.com',
  antispamWord: 'real_email-real_email',
  assetsHost: 'https://static.pre.mdirector.com/assets/',
  validationServerHostSuffix: '/amp-form-validation',
  gtmUrl: 'https://www.googletagmanager.com/amp.json',
  themeAssetsUrl: 'https://static.pre.mdirector.com/assets/themes/',
  paymentsUrl: 'https://payments.pre.mdirector.com',
  maxImageSizeToUpload: 5242880, // 5MB

  // GruID
  groupsAllowedToAMP: [],
  // Prevent refresh browser's warning when the editor content has been changed without saving.
  disablePageRefreshWarning: true,
  avoidConfirmMessages: true,
});

